export const ENTITY_PATCH_OPERATION_TYPES = Object.freeze({
  'SET': 'set',
  'DELETE': 'delete',
  'ADD': 'add',
  'REMOVE': 'remove'
})

export const createEntityPatchOperation = ({ type = ENTITY_PATCH_OPERATION_TYPES.SET, value, property }) => {
  return {
    operation: type,
    value,
    property
  }
}


// WEBPACK FOOTER //
// ./src/utils/operations.js